export default {
  10001: 'Please enter your username or mail number',
  10002: 'Email number entered incorrectly',
  10003: 'user name input error',
  10004: 'Password entered incorrectly',
  10005: 'Account is at risk. Please reach out to support team by email',
  10006: 'Username already exists',
  10007: 'Email number already exists',
  10008: 'User status is wrong',
  10009: 'No corresponding user found',
  10010: 'Expert Advisor product is incorrect',
  10011: 'Transaction failed: Insufficient account balance',
  10012: 'No corresponding days found',
  10013: 'Investment amount is wrong',
  10014: 'Quant settlement product is incorrect',
  10015: 'Not currently available for trading',
  10016: 'Incorrect purchase amount',
  10017: 'No corresponding period found',
  10018: 'Failed to obtain system parameters',
  10019: 'The current authentication status of this user is incorrect',
  10020: 'Collection status is incorrect',
  10021: 'Receiving address not filled in',
  10022: 'User is not authenticated',
  10023: 'The loan period is set incorrectly',
  10024: 'Loan amount is out of range',
  10025: 'Already purchased the same product, please do not purchase it again',
  10026: 'Please select a withdrawal method',
  10027: 'Loan amount cannot be empty',
  10028: 'Loan term cannot be empty',
  10029: 'Loan amount must be greater than 0',
  10030: 'Loan term configuration does not exist',
  10031: 'Loan amount is below the minimum value',
  10032: 'Loan amount exceeds the maximum value',
  10033: 'Loan record ID cannot be empty',
  10034: 'Loan record does not exist',
  10035: 'No permission to operate this loan record',
  10036: 'Loan status does not allow repayment',
  10037: 'Insufficient account balance',
  10038: 'Repayment application is under review, please do not apply repeatedly',
  10039: 'Failed to submit repayment application',
  10040: 'Repayment application failed',
  10088: 'Email parameter error, please check and re-enter',
  10089: 'Verification code already sent, please do not request again',
  10090: 'Verification code has expired, please resend',
  10091: 'Incorrect verification code',
  10092: 'This email is already registered',
  10093: 'Wallet address cannot be empty',
  10094: 'VIP level insufficient, requires {level} or above',
  10095: 'Investment amount exceeds the maximum limit',
  10096: 'Nonce is invalid or expired, please request again',
  10097: 'Signature message cannot be empty',
  10098: 'Nonce in signature message does not match',
  10099: 'Address in signature message does not match',
  10100: 'Signature verification failed, please try again',
  10101: 'Signature address does not match',
  10102: 'Failed to retrieve order data',
  10103: 'Order not found',
  10104: 'No permission to access this order',
  10105: 'Failed to get current price',
  10106: 'Order status does not allow closing position',
  10107: 'Spot trading does not support short selling. Buy first, then sell your position.',
  10108:
    'US stocks are outside trading hours (Mon-Fri 9:30 AM-4:00 PM ET). Please try again later.',
  10109:
    'Forex/precious metals are outside trading hours (Sun 5:00 PM-Fri 5:00 PM ET). Please try again later.',
  10110: 'Invalid trading quantity. Please enter a value greater than 0.',
  20001: 'Submission for review successful',
  20002: 'Recharge added successfully and submitted for review',
  20003: 'Withdrawal added successfully and submitted for review',
  20004: 'Purchase successful',
  20005: 'Successfully modified',
  20006: 'This email is already registered',
  20007: 'Google login failed, please try again',
  20024: 'You have already purchased the same product, please do not purchase again',
  20094: 'Withdrawal limit exceeded, limit per person per day: 1',
  20095: 'Withdrawal pending review, please do not repeat the operation',
  20096: 'Purchase failed (limited 2 times)',
  20097: 'Purchase failed (limited 3 times)',
  20098: 'Purchase order limit: 3 per user',
  20099: 'Purchase order limit: 2 per user',
  20100: 'Purchase order limit: 1 per user',
  20101: 'Automatic trading engine for this product is not yet enabled',
  20102:
    'Your account has been frozen. Trading and withdrawals are temporarily unavailable. Please contact support if you have questions.',
  20103: 'Your login session has expired. Please log in again.',
  20104: 'You are not logged in. Please log in.',
  20105: 'Please enter withdrawal PIN',
  20106: 'Incorrect withdrawal PIN',
  20107: 'Please enter withdrawal PIN',
  20108: 'Please enter a valid PIN',
  20109: 'The two PINs do not match',
  20110: 'PIN set successfully',
  20111: 'Failed to set PIN',
  20112: 'Please set a withdrawal PIN first',
  20115: 'Please enter your current withdrawal PIN',
  20116: 'Current withdrawal PIN is incorrect',
  20117: 'New PIN must be different from the current PIN',
  20118: 'Withdrawal PIN is already set; please use the change option',
  20119: 'Withdrawal PIN updated successfully',
  Invite: {
    CopyLink: 'Copy',
    FillInAccount: 'Fill in the online form and open a trading account',
    Fund: 'Fund',
    FundYourPrefer: 'Fund your account via any funding methods you prefer',
    InviteFriends: 'Invite friends',
    InviteYourFriends: 'Invite Your Friends',
    Register: 'Register',
    StartTradingPlatform: 'Start trading with our award-winning trading platform',
    Trade: 'Trade',
    WhenYourRewards:
      'Invite your friends and family to join us, and reap the rewards together while embarking on a journey towards financial prosperity!',
  },
  Market: {
    CreateAPlanToTrade: 'Create a plan to trade',
    ETF: 'ETF',
    ExpectedReturn: 'Expected return',
    LastPrice: 'Last price',
    Lots: 'Lots',
    OpenPrice: 'Open price',
    OrderAgain: 'Order again',
    OrderNumber: 'Order number',
    Price: 'Price',
    Prices: 'Price...',
    Sizes: 'Size...',
    SpotPrice: 'Spot price',
    StopLossPrices: 'Stop Loss Price...',
    TakeProfitPrices: 'Take profit price...',
    WantMoreStableEarning: 'Want more stable earning',
    WhatIsSmartTrading: 'What is smart trading?',
    available: 'Available',
    buy: 'Buy',
    buyLong: 'Buy/Long',
    buyLongBtn: 'Buy Long',
    chart: 'Chart',
    checkoutSuccess: 'checkout success',
    close: 'Close',
    confirm: 'Confirm',
    contracts: 'Spot',
    create: 'Create',
    cypto: 'Crypto',
    day: 'day',
    down: 'Down',
    estimation: 'Estimation',
    forex: 'Forex',
    free: 'Fee',
    frees: 'Fee',
    futures: 'Commodities',
    high: 'High',
    hour: 'hour',
    investment: 'lnvestment',
    leverage: 'Leverage',
    limit: 'Limit',
    low: 'Low',
    market: 'Market',
    min: 'min',
    mon: 'mon',
    name: 'Name',
    notOpen: 'The function is not yet open',
    open: 'Open price',
    options: 'Quant Settlement',
    optionsTime: 'Settlement Time',
    orderConfirm: 'Order Confirm',
    quantity: 'Quantity',
    requiredAmount: 'Amount due',
    requiredMargin: 'Amount due',
    return: 'return',
    sell: 'Sell',
    sellShort: 'Sell/Short',
    sellShortBtn: 'Sell Short',
    spot: 'Spot',
    spotBuy: 'Buy',
    spotSell: 'Sell',
    stocks: 'Stocks',
    stopLoss: 'Stop Loss',
    stopLossPrice: 'Stop loss price',
    takeProfit: 'Take Profit',
    takeProfitPrice: 'Take profit price',
    time: 'Time',
    up: 'Up',
    volume: 'Volume',
    watchlist: 'Watchlist',
    watchlistAdded: 'Added to watchlist',
    watchlistRemoved: 'Removed from watchlist',
    week: 'week',
  },
  SmartTrading: {
    InterInvestmentAmount: 'Enter investment amount...',
    SelectATimeframe: 'Select a timeframe',
    amount: 'Amount',
    create: 'Create',
    createAPlan: 'Create a plan',
    cycle: 'Cycle',
    dailyRor: 'Daily Ror',
    dailyYield: 'Daily yield',
    days: 'Days',
    daysUnit: 'Days',
    expirationTime: 'Expiration time',
    investment: 'Amount',
    investmentRange: 'Amount Limit',
    product: 'Product',
    runTime: 'Run time',
    smartTradingClose: 'Closed',
    smartTradingRunning: 'Ongoing',
    smrtTrading: 'Smart trading',
    startTime: 'Start time',
    status: 'Status',
    timeframe: 'Timeframe',
    todaysEarnings: "Today's Earnings",
    totalRevenue: 'Total Revenue',
    transaction: 'Transaction',
  },
  about: {
    aboutUs: 'About Us',
  },
  aboutUs: {
    about: 'About Us',
    subtitle1: 'Company Profile',
    subtitle2: 'Partner',
    title: 'About {title}',
  },
  account: {
    BTCAmount: 'Amount',
    LOTS: 'LOTS',
    LastDigits: 'Last 6 Digits',
    Lots: 'Lots',
    PaymentAmount: 'Payment amount',
    PleaseUploadSubmission:
      'Please upload a screenshot of your cryptocurrency payment and wait for verification after submission',
    Preview: 'Preview',
    SelectImage: 'Select Image',
    Supports: 'Supports: JPG, JPEG2000, PNG',
    TransactionHash: 'Transaction Hash',
    UploadProof: 'Upload Proof',
    UploadYourScreenshot: 'Upload your transfer screenshot',
    WithdrawalPIN: 'Withdrawal PIN',
    accountVerification: 'Account Verification',
    address: 'Address',
    allOrders: 'All orders',
    amount: 'Amount',
    approved: 'Approved',
    balance: 'Balance',
    buy: 'BUY',
    cancel: 'Cancel',
    changeLanguage: 'Change Language',
    changePassword: 'Change Password',
    close: 'Close',
    closePrice: 'Close price',
    closeTime: 'Close time',
    closed: 'Closed',
    completed: 'Completed',
    confirmWithdrawalPIN: 'Confirm withdrawal PIN',
    contactUs: 'Contact us',
    copyAddress: 'Copy address',
    copySuccess: 'Copied successfully',
    createTime: 'Create time',
    currentEarnings: 'Current Earnings',
    cycle: 'Cycle',
    dailyRate: 'Daily Rate',
    dailyRor: 'Daily Ror',
    days: 'Days',
    demo: 'Demo',
    deposit: 'Deposit',
    depositWithdraw: 'Deposit & withdrawal',
    down: 'Down',
    downloadPDF: 'Download PDF',
    earlyExist: 'Early Exist',
    earlyExit: 'Early exit',
    earlyExitTip:
      'If the transaction is stopped early, the system will automatically deduct {num} of the principal as liquidated damages, and your total income will be deducted',
    earnedDays: 'Earned Days',
    earning: 'Earning',
    enterWithdrawalPIN: 'Enter withdrawal PIN',
    expandMore: 'Expand More',
    expirationTime: 'Expiration time',
    failed: 'Failed',
    financial: 'Financial',
    freeMargin: 'Margin Used',
    futures: 'Spot',
    helpCenter: 'Help Center (FAQs)',
    holding: 'Holding',
    investmentAmount: 'Investment Amount',
    investmentPeriod: 'Investment Period',
    investmentTime: 'Investment Time',
    inviteFriends: 'Invite Your Friends',
    lastPrice: 'Last price',
    lever: 'Lever',
    liquidatedDamages: 'Liquidated damages',
    loan: 'Loan',
    logOut: 'Log out',
    logoutConfirm: 'Are you sure you want to log out?',
    margin: 'Expected Profit',
    maturityTime: 'Maturity Time',
    myAccount: 'My account',
    newWithdrawalPIN: 'New withdrawal PIN',
    noSpotPosition: 'No spot position to sell',
    notification: 'Notification',
    notifications: 'Notifications',
    okay: 'Okay',
    oldWithdrawalPIN: 'Current withdrawal PIN',
    open: 'Open price',
    openPrice: 'Open price',
    openShort: 'Open',
    openTime: 'Open time',
    options: 'Quant Settlement',
    optionsOrder: 'Quant Settlement Order',
    order: 'Order',
    pending: 'Pending',
    pips: 'Pips',
    productName: 'Product Name',
    profit: 'Profit',
    profitRate: 'Profit Rate',
    putAway: 'Put away',
    receiveAddress: 'Withdrawal address',
    recreatePlan: 'Recreate Plan',
    refund: 'Refund',
    refundTip: 'Funds will be refunded to your live account, please check it.',
    repayNow: 'Repay now',
    repayment: 'Repayment',
    repaymentAmount: 'Repayment amount',
    repaymentDate: 'Repayment date',
    repeatOrder: 'Repeat this order',
    reviewed: 'To be reviewed',
    runTime: 'Run time',
    save: 'Save',
    sell: 'SELL',
    setWithdrawalPIN: 'Set withdrawal PIN',
    settings: 'Settings',
    settled: 'Settled',
    smart: 'Smart trading',
    spot: 'Spot',
    spotBuy: 'Buy',
    spotClose: 'Sell to close',
    spotSell: 'Sell',
    startTime: 'Start time',
    staticincome: 'Wallet income',
    status: 'Status',
    success: 'Success',
    time: 'Time',
    todayEarnings: "Today's Earnings",
    todayProfit: "Today's Profit",
    tokenType: 'Token Type',
    totalInterest: 'Total interest',
    totalProfit: 'Total profit',
    totalRepayment: 'Total Repayment',
    totalRevenue: 'Total Revenue',
    transFees: 'Transaction Fees',
    transRecord: 'Transaction record',
    transaction: 'Transaction',
    type: 'Type',
    up: 'Up',
    withdraw: 'Withdrawal',
    withdrawNow: 'Withdrawal now',
    withdrawalPINBound: 'Withdrawal PIN is set',
    withdrawalPINNotSet: 'Not set',
    withdrawalPINRequired: 'Withdrawal PIN is required for this transaction',
  },
  amount: 'Amount',
  bangZhuZhongXin: 'Help Center',
  biaoDian: 'punctuation',
  board: {
    content: 'This software meets all your needs in a professional manner with the best technology',
    continue: 'Continue',
    skip: 'Skip',
    title: 'The best trading platform',
  },
  bread: {
    introduction: 'Introduction',
  },
  chaKan: 'Check',
  chongZhi: 'Deposit',
  chongZhiJinexiaoYuZuiDiChongZhiJinE:
    'The recharge amount is less than the minimum recharge amount',
  chongZhiPingZheng: 'Transfer screenshot',
  chongZhiShiJian: 'Deposit time',
  chongZhiShuoMing: 'Deposit instructions:',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    'Deposit instructions: The minimum deposit amount for USDT is 120, the minimum deposit amount for BTC is 0.015, and the minimum deposit amount for ETH is 0.2',
  close: 'Close',
  common: {
    loadMore: 'Load More',
  },
  'customerService.error': 'Customer support is temporarily unavailable. Please try again later.',
  'customerService.close': 'Close',
  'customerService.connected': 'Connected',
  'customerService.imageAlt': 'Customer support image',
  'customerService.imagePreview': 'Image preview',
  'customerService.imageTooLarge': 'Image size cannot exceed 5MB',
  'customerService.imageTypeUnsupported': 'Only PNG, JPEG or WebP images are supported',
  'customerService.imageUnavailable': 'Image unavailable',
  'customerService.loadFailed':
    'The online customer support service could not be loaded. Please try again later.',
  'customerService.loading': 'Loading…',
  'customerService.loginRequired': 'Please log in to contact support',
  'customerService.openImage': 'Open image',
  'customerService.placeholder': 'Type a message, press Enter to send',
  'customerService.send': 'Send',
  'customerService.sendImage': 'Send image',
  'customerService.reconnecting': 'Reconnecting',
  'customerService.title': 'Support',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    "Most websites take steps to protect users' personal information, such as using encryption technology to protect passwords.",
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    'Most websites allow users to change their personal information, such as changing their email address or password. \nHowever, some information may not be changed, such as username.',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    'No interest is required within {num} days after the loan is taken, and interest will be paid after {num} days.',
  daiShenHe: 'Pending review',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    'However, if the website or application you use has a security vulnerability, your personal information may be exposed.',
  dangQiLiRun: 'Profit for the current period',
  dangQianLiXi: 'current interest',
  daoQiHuanXiHuanBen: 'Repay interest and principal when due',
  daoQiShiJian: 'Expire date',
  demo_mode: 'Demo mode, operation not allowed',
  dengLuChengGong: 'login successful',
  di: 'Low',
  dianHuaHaoMa: 'Telephone number:',
  dieJiaLiShuai: 'Overlay interest rate:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  financial: {
    amountOutOfRange: 'Amount Out of Range',
    confirmInvestment: 'Confirm Investment',
    dailyRate: 'Daily Rate',
    days: 'Days',
    earning: 'Earning',
    expectedReturn: 'Expected Return',
    insufficientBalance: 'Insufficient Balance',
    investNow: 'Invest Now',
    investmentAmount: 'Investment Amount',
    investmentPeriod: 'Investment Period',
    investmentSuccess: 'Investment Successful',
    maxAmount: 'Max Investment',
    minAmount: 'Min Investment',
    myInvestments: 'My Investments',
    pleaseEnterAmount: 'Please Enter Amount',
    productList: 'Product List',
    settled: 'Settled',
    status: 'Status',
    title: 'Financial Products',
    totalInvestment: 'Total Investment',
    totalReturn: 'Total Return',
  },
  gao: 'high',
  gouMai: 'Buy NFT art',
  gouMaiChengGong: 'Purchase successful',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    'International Currency Accounts Contact Online Support Services Matching',
  home: {
    Application: 'Application',
    AvailableOnThe: 'Available on the',
    CreditCard: 'Crypto deposit',
    CreditCardInfo:
      'By using cryptocurrency for deposit, an additional layer of security is obtained, and quick transaction processing is ensured.',
    CryptocurrenciesListed: 'Cryptocurrencies listed',
    GetStarted: 'Get started',
    NewFeaturesInOnline: 'New features in online',
    NewFeaturesInOnlineInfo: 'Get to know the wonderful features of this complete platform',
    RegisteredUsers: 'Registered users',
    allChains: 'All Chains',
    announcementClose: 'Close announcement',
    announcementLabel: 'Notice',
    announcementView: 'View details',
    announcementAmount: 'Lent amount',
    announcementAnnualRate: 'Annual yield',
    announcementBelowMinimum: 'Below {amount} USDT',
    announcementCompoundInterest: 'Compound interest',
    announcementCurrentConfig: 'Current settings',
    announcementEarningMode: 'Interest method',
    announcementRateNotice:
      "Earnings follow the platform's current tier rules. Final amounts are shown in Assets and settlement records.",
    announcementRatesLoading: 'Loading current yield tiers…',
    announcementSettlement: 'Daily settlement times',
    announcementSimpleInterest: 'Simple interest',
    announcementYieldEyebrow: 'Yield information',
    announcementYieldIntro:
      'Higher lending amounts receive higher annual yields. Amounts below the first tier can still participate but earn no interest.',
    announcementYieldTitle: 'Current yield details',
    appLicationInfo:
      'Mobile banking that throws out the role book and gives you a precision tool for managing your finances.',
    billion: 'billion',
    billionInfo: 'Average 24-hour trading volume',
    button1Title: 'Lowest transactions fees',
    button1Title1: 'Trade all assets in one place',
    button1Title2: 'Forex, crypto, stocks, indices, commodities',
    button2Title: 'Low interest rate and higher amount',
    button2Title1: 'Cryptocurrency loans',
    button2Title2: 'Borrow cryptocurrency spots without any collateral',
    button3Title: 'Simple and stable',
    button3Title1: 'Smart trading',
    button3Title2: 'One click to create your earning plan',
    button4Title: 'Help children around the world',
    button4Title1: 'NFTs charity',
    button4Title2: 'Buy NFT artwork to support UNICEF',
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: 'Provide liquidity to the lending pool to earn interest',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: 'Buy, trade, and hold 350+ cryptocurrencies on the best platform.',
    loading: 'Loading...',
    million: 'million',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: 'Wallet can Swap BTC to USD ',
    noticeInfo1: 'Operate with a Demo Account',
    onlineSupport: 'Online Support',
    period: 'Period',
    periodDaySuffix: ' days',
    periodDays: '{count} day | {count} days',
    poolCount: '{count} pools',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
    totalPool: 'Total Lending Pool',
    totalYieldRate: 'Yield Rate',
  },
  huanKuanZhong: 'Repayment in progress',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    'Welcome to use our award-winning financial trading platform and explore the future financial world with global investors!',
  jiXiShiJian: 'Interest accrual time',
  jiXuTouZi: 'Keep investing',
  jiangTuPianTuoFangDaoCiChuHuo: 'Drag and drop an image here, or',
  jieZhiShiJian: 'deadline',
  jiuMiMa: 'Old Password',
  juJueYuanYin: 'Rejection Reason',
  kai: 'open',
  lendingAssets: {
    addAsset: 'Authorize another asset',
    authorizedBalance: 'Authorized Balance',
    availableAmount: 'Available to Withdraw',
    dailyOrders: 'Daily Settlement Orders',
    dailyProfit: 'Daily Profit',
    estimated24hEarnings: 'Est. Next 24h Earnings',
    estimated24hHint: "Projected tomorrow's earnings based on your current balance and tier rate",
    joinPool: 'Join a Pool',
    loadMore: 'Load more',
    needAuth: 'Join a lending pool to view your balances and earnings',
    needLogin: 'Please log in to view your assets',
    noOrders: 'No settlement orders yet',
    pageDesc: 'View authorized balances, lending pool earnings, and daily settlement orders',
    poolEarnings: 'Lending Pool Earnings',
    todayEarnings: 'Today',
    totalEarnings: 'Total Earnings',
    withdraw: 'Withdraw',
    withdrawRecords: 'Withdraw Records',
    withdrawnAmount: 'Withdrawn',
    walletBalances: 'Wallet Balances',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      "<p><strong>Document Version:</strong> V3.28 &nbsp;|&nbsp; <strong>Release Date:</strong> 2022 &nbsp;|&nbsp; <strong>Document Type:</strong> Product Whitepaper &amp; Security Assessment Summary</p>\n\n<h2>1. Executive Summary</h2>\n<p>This Lending Pool module is an on-chain liquidity lending service built on decentralized finance (DeFi) money market protocols. Through open-source smart contracts and programmatic interest rate models, the system connects users' digital assets to established on-chain lending markets, enabling <strong>yield on deposits, collateralized borrowing, and shared liquidity</strong>.</p>\n<p>The module does not rely on manual intervention for day-to-day fund allocation. Key metrics such as interest rates, capacity limits, and utilization are determined in real time by on-chain markets and displayed transparently via multi-source data aggregation and scheduled synchronization.</p>\n\n<h2>2. Industry Background &amp; Product Positioning</h2>\n<p>Traditional lending depends on centralized institutions for credit assessment and fund matching. DeFi lending protocols use smart contracts to automatically match supply and demand, with over-collateralization and liquidation mechanisms to protect system solvency.</p>\n<p>This Lending Pool module is positioned as:</p>\n<ul>\n  <li><strong>On-chain money market gateway:</strong> Aggregates lending pool data across multiple chains and protocols;</li>\n  <li><strong>Programmatic yield distribution:</strong> Automatically settles earnings on a fixed schedule based on authorized balances and market APY;</li>\n  <li><strong>Transparent &amp; verifiable:</strong> Pool TVL, APY, utilization, and LTV metrics are traceable to public on-chain data;</li>\n  <li><strong>Non-custodial by design:</strong> Asset authorization and on-chain interactions are initiated from the user's wallet.</li>\n</ul>\n\n<h2>3. System Architecture</h2>\n<h3>3.1 Architecture Overview</h3>\n<ul>\n  <li><strong>User interface layer:</strong> Web/mobile UI for wallet connection, authorization, pool browsing, and earnings queries;</li>\n  <li><strong>Business service layer:</strong> Authentication, authorization management, yield order generation, and multilingual content;</li>\n  <li><strong>Data aggregation layer:</strong> Syncs lending pool metrics from public DeFi data sources on a schedule;</li>\n  <li><strong>On-chain protocol layer:</strong> Audited open-source lending protocol smart contracts execute deposit and borrow logic.</li>\n</ul>\n\n<h3>3.2 Core Metrics</h3>\n<table>\n  <thead>\n    <tr><th>Metric</th><th>Description</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>Total pool assets in USD; reflects market depth</td></tr>\n    <tr><td>Supply APY</td><td>Deposit annual yield from base rate plus protocol rewards</td></tr>\n    <tr><td>Borrow APY</td><td>Annual cost paid by borrowers</td></tr>\n    <tr><td>Utilization Rate</td><td>Ratio of borrowed to available funds</td></tr>\n    <tr><td>Max LTV</td><td>Maximum loan-to-value ratio before liquidation</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>Per-asset limits to control concentration risk</td></tr>\n    <tr><td>Available Liquidity</td><td>Liquidity available for immediate borrowing</td></tr>\n  </tbody>\n</table>\n\n<h2>4. User Flow &amp; Yield Mechanics</h2>\n<ol>\n  <li><strong>Connect wallet</strong> via Web3 wallet;</li>\n  <li><strong>Authorize assets</strong> (USDT, USDC, etc.) with on-chain Approve;</li>\n  <li><strong>Join the lending pool</strong> to enter the yield calculation queue;</li>\n  <li><strong>Yield settlement</strong> once daily based on authorized balance and market rates;</li>\n  <li><strong>View assets</strong> under My Portfolio for balances and settlement history.</li>\n</ol>\n<p><strong>Historical APY does not guarantee future returns.</strong></p>\n\n<h3>4.3 Fees</h3>\n<h4>How are DeFi Earn fees charged?</h4>\n<p>On-chain transactions require gas fees to complete interactions with smart contracts, including subscription and yield claiming. For certain assets, the DeFi lending pool and vault managers may charge a performance fee as a percentage of your actual profits; your principal is not affected.</p>\n\n<h2>5. Security Design</h2>\n<ul>\n  <li>Underlying protocols use audited open-source contracts with on-chain core logic;</li>\n  <li>Non-custodial architecture; no private keys or seed phrases stored;</li>\n  <li>Minimal Token Approve permissions; revocable anytime in the wallet;</li>\n  <li>Token auth, HTTPS transport, RBAC admin access, and operation audit trails.</li>\n</ul>\n\n<h2>6. Security Assessment Summary</h2>\n<table>\n  <thead>\n    <tr><th>Item</th><th>Result</th><th>Notes</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>Smart contract dependencies</td><td><strong>Pass</strong></td><td>Publicly audited DeFi protocol contracts</td></tr>\n    <tr><td>Non-custodial &amp; key management</td><td><strong>Pass</strong></td><td>No private key storage</td></tr>\n    <tr><td>API &amp; authentication</td><td><strong>Pass</strong></td><td>Token auth and HTTPS in place</td></tr>\n    <tr><td>Data sync &amp; consistency</td><td><strong>Pass</strong></td><td>Scheduled sync with snapshots</td></tr>\n    <tr><td>Yield settlement logic</td><td><strong>Pass</strong></td><td>Explicit rules; auditable orders</td></tr>\n  </tbody>\n</table>\n\n<h2>7. Risk Disclosure</h2>\n<ul>\n  <li><strong>Smart contract risk:</strong> Undiscovered vulnerabilities may exist;</li>\n  <li><strong>Market risk:</strong> APY can fluctuate significantly;</li>\n  <li><strong>Liquidation risk:</strong> Collateral price drops may trigger liquidation;</li>\n  <li><strong>Stablecoin de-peg risk:</strong> USDT/USDC may deviate from $1.00;</li>\n  <li><strong>Regulatory risk:</strong> DeFi regulation is evolving globally.</li>\n</ul>\n<p><strong>This module does not provide investment advice and does not guarantee fixed returns.</strong></p>\n\n<h2>8. Glossary</h2>\n<ul>\n  <li><strong>APY:</strong> Annual Percentage Yield;</li>\n  <li><strong>TVL:</strong> Total Value Locked;</li>\n  <li><strong>LTV:</strong> Loan-to-Value ratio;</li>\n  <li><strong>Approve:</strong> ERC-20 token authorization;</li>\n  <li><strong>Liquidation:</strong> Automatic collateral sale when debt is under-collateralized.</li>\n</ul>\n\n<p>— For informational purposes only. Not legal, financial, or investment advice. Verify on-chain data via block explorers and official protocol interfaces.</p>",
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowApy: 'Borrow APY',
    borrowCapacity: 'Borrow Capacity',
    borrowCapacityFilled: 'Borrow Capacity Filled',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    borrowingEnabled: 'Borrowable',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositCapacity: 'Deposit Capacity',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    eligible: 'Eligible as collateral',
    exposure: 'Exposure',
    loading: 'Loading...',
    maxLtv: 'Max LTV',
    no: 'No',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    period: 'Period',
    poolCount: 'Pool Count',
    price: 'Price',
    protocol: 'Protocol',
    remainingCapacity: 'Remaining Capacity',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    subscribe: 'Subscribe',
    subscribed: 'Subscribed',
    title: 'Pool Detail',
    totalBorrows: 'Total Borrows',
    totalDeposits: 'Total Deposits',
    totalPoolDepositDesc: 'Deposit USDT/USDC to earn yield',
    utilization: 'Utilization',
    yes: 'Yes',
    yieldRate: 'Yield Rate',
  },
  lendingIdentity: {
    needLogin: 'Please log in before identity verification',
    needVerifyHint: 'Please complete identity verification before joining the lending pool',
    pageDesc:
      'Complete identity verification to join the lending pool and access deposit and borrowing services',
    pendingHint: 'Your identity verification is under review. Please wait patiently',
  },
  lendingMenu: {
    assets: 'Assets',
    chooseDepositAsset: 'Choose an asset to deposit',
    chooseDepositHint: 'Deposit assets into a lending pool to earn yield and enable borrowing',
    copyUid: 'Copy UID',
    customerService: 'Customer Service',
    depositAssetAction: 'Deposit {symbol}',
    earnings: 'How to Earn',
    empty: 'No content yet',
    explore: 'Explore',
    footerDesc:
      'A next-generation on-chain money market built on open-source smart contracts. Programmatic rules replace manual control, delivering secure and transparent liquidity deposit and lending services for Web3 users worldwide.',
    getStarted: 'Join Now',
    home: 'Home',
    identityVerification: 'Identity Verification',
    intro: 'About',
    language: 'Language',
    noAssetPool: 'No lending pool found for this asset',
    rulesSecurity: 'Rules & Security',
    security: 'Security',
    theme: 'Appearance',
    uid: 'UID',
    whitepaper: 'Whitepaper',
    yieldLadder: 'Yield Ladder',
  },
  lendingTheme: {
    auto: 'System',
    dark: 'Dark',
    light: 'Light',
    title: 'Appearance',
  },
  lendingYieldLadder: {
    balance: 'Individual Loan Principal (USDT)',
    compoundInterest: 'Compound interest',
    earningMode: 'Earning mode: {mode}',
    empty: 'No tiers configured yet',
    loading: 'Loading tier rates…',
    noteFixed: 'Settled daily at the fixed rate for this tier',
    noteRange: 'Settled daily at the range maximum',
    notes: 'Notes',
    rate: 'Daily Rate Range',
    settlementHours: 'Configured settlement: {hours}',
    simpleInterest: 'Simple interest',
  },
  liangCiMiMaBuYiZhi: 'Two passwords are inconsistent',
  loan: {
    Browse: 'Browse',
    address: 'Address:',
    birthdate: 'Birthdate:',
    borrow: 'Borrow',
    borrowNow: 'Borrow now',
    borrowPlaceholder: 'I want to borrow...',
    browse: 'browse',
    checkIn: 'Submission successful',
    confirm: 'Confirm',
    continue: 'Continue',
    country: 'Country:',
    dailyRate: 'Daily interest rate',
    days: 'Days',
    document: 'Document:',
    done: 'Done!',
    driverLicense: 'driver license',
    dropHere: 'Drop your image here',
    ensure: 'Ensure',
    female: 'Female',
    firstName: 'First name:',
    idCard: 'ID Card',
    inHand: 'in hand',
    lastName: 'Last name:',
    launchCamera: 'Launch camera',
    loanAgreement: 'Loan Agreement',
    loanAmount: 'Loan amount',
    loanAmountRangeError: 'Loan amount must be between {min} - {max} USD',
    loanAmountTooHigh: 'Loan amount cannot exceed {max} USD',
    loanAmountTooLow: 'Loan amount cannot be less than {min} USD',
    loanDetail: 'Loan detail',
    loanTerm: 'Loan term',
    male: 'Male',
    notVerifyBtn: 'Start verification',
    notVerifyTip: 'Verify your identity and get more loan amount!',
    or: 'or',
    passport: 'Passport',
    pendingReview: 'Pending review',
    phone: 'Email:',
    phonePlaceholder: 'Inter your Email...',
    reSign: 'Re-sign',
    resubmit: 'Resubmit',
    sex: 'Female / Male:',
    sign: 'Sign',
    signTip: 'Please confirm and sign',
    signed: 'Signed',
    startVerfication: 'Start verification',
    submit: 'Submit',
    supports: 'Supports: JPG, JPEG2000, PNG',
    takePhoto: 'Take photo',
    term: 'Loan term (Days)',
    tipIdCardBack: 'Place the Back of ID Card in the Frame',
    tipIdCardFront: 'Place the Front of ID Card in the Frame',
    tipNotPass:
      'We apologize that your KYC application did not pass the verification process. Please resubmit the correct application materials to complete the KYC verification. If you have any questions or need assistance, please feel free to contact our customer service team at any time.',
    tipTakePhoto: 'Please take a photo with your',
    tipVerifiedSuccess:
      'Congratulations! Your KYC application has been verified and you can now enjoy higher-level services.',
    tipWaitForResult:
      'Thank you for submitting your KYC documentation. Our team will review your information within 48 hours. Please be patient while awaiting the results.',
    title: 'Loan account',
    totalAmount: 'Total interest amount',
    verifiedSuccessfully: 'Verified successfully',
    verifiedUnsuccessfully: 'Verified unsuccessfully',
    verifyBtn: 'Successfully verified',
    verifyTip: 'Get instant funding to secure your investments!',
  },
  login: {
    btnContinueFacebook: 'Continue with Facebook',
    btnContinueGoogle: 'Continue with Google',
    btnLogin: 'Login',
    btnLoginFacebook: 'Login by Facebook',
    btnLoginGoogle: 'Login by Google',
    btnNext: 'Next',
    btnRecovery: 'Recovery',
    btnRecoveryPsd: 'Recovery password',
    btnRegister: 'Register',
    btnRegisterFacebook: 'Register by Facebook',
    btnRegisterGoogle: 'Register by Google',
    btnSend: 'Send',
    btnSignup: 'Sign-up with Email',
    email: 'Email',
    emailPlaceholder: 'Enter your email, e.g. name@example.com',
    emailTips: 'This email is already registered.',
    hasAccount: 'Already have an account?',
    hasNotAccount: "I don't have an account?",
    inputCode: 'Please input code',
    inputEmail: 'Please enter your email',
    inputPassword: 'Please input password',
    inputPhone: 'Please enter your email',
    inputUsernameOrEmail: 'Enter your username or email',
    labelEmail: 'Email:',
    labelEmailCode: 'Verification Code:',
    labelPsd: 'Password:',
    labelPsdNew: 'New Password:',
    labelPsdRepeat: 'Confirm Password:',
    labelUsername: 'Username:',
    labelUsernameOrEmail: 'Username or email:',
    phone: 'Email:',
    phoneTips: 'This email is already registered.',
    starLogin: "Let's start with login!",
    starRegist: "Let's start with register!",
    starReset: "Let's recovery by email!",
    tipRegisterContent:
      'Complete your registration and unlock the gateway to a world of exciting investment opportunities, paving the way for financial success and growth!',
    tipRegisterTitle: 'Sign up and embark on your prosperous investment journey!',
    useEmailRegister: 'Register with email',
    usePhoneRegister: 'Register with phone number',
    username: 'Username',
    usernameOptional: 'Username (optional; if empty, same as email)',
    usernameTips: 'The username already exists!',
    welcome: 'Welcome to',
  },
  navBottom: {
    bottomCompany: 'Company',
    bottomCompanyItem1: 'About Us',
    bottomCompanyItem2: 'License Supervision',
    bottomCompanyItem3: 'Help Center',
    bottomCompanyItem4: 'Online Support',
    bottomOther: 'Statements',
    bottomOtherItem1: 'Legal Information',
    bottomOtherItem2: 'Disclaimer',
    bottomOtherItem3: 'Risk Warning',
    bottomOtherItem4: 'Cookie Policy',
    bottomOtherItem5: 'About Advertising',
    bottomPolicy: 'Policies',
    bottomPolicyItem1: 'Terms & Conditions',
    bottomPolicyItem2: 'Privacy Policy',
    bottomProduct: 'Products',
    bottomProductItem1: 'Markets',
    bottomProductItem2: 'Investment & Lending',
    bottomProductItem3: 'NFT for Charity',
    bottomProductItem4: 'Smart Trading',
  },
  navTab: {
    btnLogin: 'Login',
    btnSignup: 'Sign up',
    language: 'Language',
    languageTips: 'Choose a language and region',
    tabMenu1: 'Home',
    tabMenu2: 'Market',
    tabMenu3: 'Smart trading',
    tabMenu4: 'Loan',
    tabMenu5: 'Financial',
    tabMenu6: 'NFTs',
    tabMenu7: 'Account',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: 'The stop loss price you entered is unreasonable',
  ninShuRuDeZhiYingJiaGeBuHeLi: 'The take profit price you entered is unreasonable',
  notifications: {
    deposit: {
      content:
        'Dear user, we have received your deposit of \u0024{amount}USD, and successfully added \u0024{amount} to your account balance.',
      title: 'Deposit Notification',
    },
    kyc: {
      content:
        'Dear user, congratulations on passing the KYC verification. You have now completed the KYC process and can enjoy higher level of services.',
      title: 'KYC Verification Passed',
    },
    loan: {
      content:
        'Dear user, congratulations on your approved loan application of \u0024{amount}. We have reviewed and approved your application, and the loan amount has been deposited into your account. Please log in to your account to view the details.',
      title: 'Loan approved',
    },
    repayment: {
      content:
        'Dear user, we have successfully received your \u0024{amount} repayment. Thank you for your continued support.',
      title: 'Repayment Successful',
    },
    withdraw: {
      content:
        'Dear user, your \u0024{amount} withdrawal application has been successfully processed. Please pay attention to the information and check it in time.',
      failed: {
        content:
          'Dear user, your withdrawal request of \u0024{amount} has failed. Please check the withdrawal details carefully and contact online support promptly.',
        title: 'Withdrawal Notification',
      },
      title: 'Withdrawal Notification',
    },
  },
  ntfs: {
    Address: 'Address',
    AllMoneyCharities: 'All money from the sale of NFTs is donated to UNICEF charities',
    BuyNFT: 'Buy NFT arts, help children around the world!',
    BuyNow: 'Buy now',
    Chain: 'Chain',
    Confirm: 'Confirm',
    Creator: 'Creator',
    CumulativeDonation: 'Cumulative donation',
    CurrentBid: 'Current bid',
    Markets: 'Markets',
    MyNFTs: 'My NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'NFTs detail',
    PlaceABid: 'Place a bid',
    RemainingTime: 'Remaining time',
    Successful: 'Successful',
    ThanksDonation: 'Thanks for you donation',
    Thisaddress: 'This item will be sent to your wallet address',
    Verified: 'Verified',
    andUNICEF: 'and the money will be donated to UNICEF',
    charity: 'charity',
  },
  null: 'unknown mistake',
  permission_denied: 'Access denied, please contact your administrator',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: 'Please switch to real account operation',
  qingShangChuanPingZheng: 'Please upload the certificate',
  qingShuRuDiZhi: 'Please enter address',
  qingShuRuShouJiHao: 'Please enter Email',
  qingShuRuShuLiang: 'Please enter trade quantity',
  qingShuRuTouZiJinE: 'Please enter investment amount',
  qingShuRuYanZhengMa: 'please enter verification code',
  qingShuRuZhengQueDeJinE: 'Please enter the correct amount',
  qingShuRuZhengQueDeYouXiang: 'please enter your vaild email',
  qingShuRuZhiSunJiaGe: 'Please enter stop loss price',
  qingShuRuZhiYingJiaGe: 'Please enter the take profit price',
  qingTianXieWanZhengXinXi: 'Please fill in complete information',
  qingZaiCiShuRuMiMa: 'Please enter password again',
  queRenMiMa: 'Confirm Password',
  repayApplicationPending: 'Repayment application under review',
  repayApplicationRejected: 'Repayment application rejected',
  repayApplicationSubmitted:
    'Repayment application submitted, please wait for administrator review',
  repaySuccess: 'Repayment successful',
  return: 'Return',
  ri: 'day',
  riLiShuai: 'Daily interest rate:',
  search: {
    SearchHere: 'Search here',
  },
  shangChuanShiBaiQingZhongShi: 'Upload failed, please try again',
  shenHeBuTongGuo: 'Failed',
  shou: 'receive',
  shouJiHao: 'Email',
  shouXuFeiShiJiDaoZhangJinE: 'Fee/actual amount received',
  shouYiZhong: 'Income',
  shouYiZhuangTai: 'income status',
  shuRuNinDeDianHuaHaoMa: 'Enter your phone number...',
  souSuo: 'search...',
  spotCloseSuccess: 'Spot position closed successfully',
  spotOrderSuccess: 'Spot order submitted successfully',
  staticIncome: 'Wallet income',
  tiJiaoChengGong: 'Submitted successfully',
  tiJiaoChongZhiPingZheng: 'Submit deposit proof',
  tiKuanFangShi: 'Withdrawal method',
  tiXian: 'Withdrawal',
  tiXianDiZhi: 'Withdrawal address',
  tiXianShiJian: 'Withdrawal time',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    'A {rate}% withdrawal fee will be charged. All withdrawals must be confirmed by blockchain network nodes before the funds can be credited to your account.',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen_bak:
    'Withdrawal requires a {rate}% handling fee, which requires confirmation from the network node before it can be deposited into the account. Please do not transfer cryptocurrency to strangers.',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen_tip:
    'Tip: Do not transfer cryptocurrency to strangers!',
  toast: {
    UnreasonablePriceProfitLoss: 'Unreasonable price setting for stop profit and stop loss',
    buyNumbers: 'Please enter the purchase quantity',
    copyError: 'Copy error!',
    copySuccess: 'Copy success!',
    email: 'please input your email',
    inputAll: 'The data input is not complete',
    loading: 'Loading...',
    logOut: 'Logged out',
    noData: 'No more data',
    notAddress: 'Please enter the address',
    notAmount: 'Please enter the amount',
    notEmail: 'E-mail format is incorrect',
    notImage: 'The image format is incorrect',
    notLoanAmount: 'Please enter the loan amount',
    notSigned: 'Not Signed',
    notSmartAmount: 'Please enter the Smart amount',
    notSupportMedia: 'Access to user media is not supported',
    notVerify: 'Please perform KYC certification',
    notWithdrawAmount: 'Please enter the Withdraw amount',
    nothingfound: 'Nothing found yet!',
    password: 'please enter password',
    passwordNotSame: 'Inconsistent password input',
    passwordRepeat: 'Please confirm your password',
    uploadImage: 'Please upload the required picture',
    userName: 'please enter user name',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    'Usually, basic information such as your Email number, username, password, and sometimes personal information and contact information are required.',
  touZiShiJian: 'investment time',
  touZiZhouQi: 'investment cycle',
  tuPianDaXiaoBuNengChaoGuo_2mb: 'Image size cannot exceed 2MB!',
  tuPianDaXiaoBuNengChaoGuo_5m: 'Image size cannot exceed 50MB!',
  uploadfailed: 'uploadFailed',
  usdtZuiDiChongZhiJinewei_120: 'The minimum deposit amount of {name} is {limit}',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    'Forex automatic trading quantification is a method that uses computer programs and algorithms to automatically execute trading strategies. \nThis method uses historical data, technical indicators, statistical models and other analytical tools to identify trading signals and automatically execute these signals when executing trades. \nForex automated trading quantification can help traders eliminate the impact of emotions, reduce erroneous transactions, and improve transaction efficiency and consistency. \nHowever, automated FX trading quantification also has some potential risks and limitations. \nFor example, automated trading programs may not be able to adapt to market changes, and the quality and effectiveness of trading programs and algorithms largely depend on the reliability and validity of historical data. \nIn addition, automatic trading may also involve technical risks, such as computer failure, network interruption, etc. Therefore, before using automated foreign exchange trading quantification, investors need to carefully evaluate their trading objectives, risk tolerance and technical capabilities, and choose a reliable trading platform \n. \nTrading platforms and automated trading programs. \nMost importantly, investors should always exercise caution and take appropriate risk management measures to protect their investments.',
  wallet: {
    activate: 'Activate',
    alreadyAuthorized: '{token} is already authorized',
    authFailed: 'Please Switch to Ethereum Mainnet to Continue.',
    authFailedRetry: 'Authorization failed, please check network connection and try again',
    authSuccess: 'Authorization successful',
    authSuccessWithReward: '{token} authorization successful! You can now enjoy wallet rewards',
    authorizationFailed: 'Failure',
    authorizationSuccess: 'Success',
    authorized: 'Authorized',
    authorizingToken: 'Authorizing {token}, please confirm in your wallet...',
    connectFailed: 'Failed to connect wallet',
    connectWallet: 'Connect wallet',
    connecting: 'Connecting...',
    justCanWallet: 'This website only accepts access from decentralized wallet Web3 browsers.',
    networkNotSupported: 'Current network is not supported, please switch to a supported network',
    noWalletDetected: 'Please Switch to Ethereum Mainnet to Continue.',
    pleaseConnectWallet: 'Please connect wallet',
    pleaseLoginFirst: 'Please connect wallet to login first',
    savingAuth: 'Saving authorization, please wait...',
    signatureLogin: {
      getNonceFailed: 'Failed to get nonce',
      loggingIn: 'Logging in...',
      loginFailed: 'Login failed',
      loginSuccess: 'Login successful',
      signatureFailed: 'Signature failed, please try again',
      signing: 'Signing, please confirm in your wallet...',
      userRejectedSignature: 'You cancelled the signature',
      verificationFailed: 'Signature verification failed',
      walletNotInstalled: 'Wallet not detected, please install MetaMask or other Web3 wallet',
    },
    status: 'Wallet Status',
    testnetDisabled: 'Testnet is disabled, please use mainnet',
    transactionCancelled: 'Transaction cancelled',
    unauthorized: 'Unauthorized',
    userCancelled: 'User cancelled the operation',
    userCancelledAuth: 'You cancelled the authorization',
  },
  walletAllowanceInsufficient: 'Current allowance is insufficient, need to re-authorize',
  walletAllowanceQueryFailed: 'Failed to query current allowance',
  walletAllowanceSufficient: 'Current allowance is sufficient, no need to re-authorize',
  walletAlreadyApproved: 'Already authorized, no need to re-authorize',
  walletApproveResult: 'Authorization successful',
  walletApproveSuccess: 'New authorization transaction successful',
  walletConfigEmpty: 'Response is empty',
  walletConfigError: 'Failed to initialize wallet configuration',
  walletConfigFailed: 'Failed to get wallet configuration',
  walletConfigLoadComplete: 'Configuration loading complete',
  walletConfigLoaded: 'Wallet configuration loaded successfully',
  walletConfigLoading: 'Starting token authorization',
  walletConfigNotLoaded: 'Not loaded',
  walletConfigStatus: 'Current configuration status',
  walletConnecting: 'Getting wallet configuration...',
  walletConnectingTo: 'connecting',
  walletContractCallFailed:
    'Contract call pre-check failed, please check contract address and parameters',
  walletContractFailed: 'Contract execution failed, please check transaction parameters',
  walletContractInfoFailed:
    'Contract basic information query failed, may not be standard ERC20 contract',
  walletContractInfoNormal: 'Contract basic information is normal',
  walletContractNotSupported: 'Token contract does not support this operation',
  walletContractPaused: 'Token contract is paused or has other restrictions',
  walletContractRejectAuth:
    'Token contract rejected authorization operation, please check if contract supports standard ERC20 authorization',
  walletContractReverted: 'Contract execution reverted, possible reasons',
  walletContractSpecialRules: 'Contract has special authorization rules',
  walletCurrentAllowance: 'Current allowance',
  walletDetecting: 'Auto-detected wallet',
  walletEthConnectFailed: 'Ethereum wallet connection failed',
  walletEthConnecting: 'Starting to connect Ethereum wallet...',
  walletGasEstimate: 'Estimated Gas usage',
  walletGasEstimateFailed: 'Gas estimation failed, transaction may fail',
  walletGetTokenContract: 'Getting token contract address',
  walletInsufficientBalance:
    'Insufficient account balance, please ensure enough ETH/TRX for gas fees',
  walletInsufficientGas: 'Insufficient transaction fees, please adjust Gas settings and try again',
  walletNetworkTimeout: 'Network connection timeout, please check network and try again',
  walletNoTokenWarning: 'User has no this token, but can still authorize',
  walletResetAllowance: 'Trying to reset allowance to 0 first...',
  walletResetAllowanceFailed: 'Failed to reset allowance, continue trying direct authorization',
  walletResetAllowanceSuccess: 'Allowance reset successful',
  walletSmartContractFailed: 'Failed to get smart contract address',
  walletTokenApproveAmount: 'Approve amount',
  walletTokenApproveTo: 'Approve to',
  walletTokenApproving: 'Approving token',
  walletTokenBalanceQueryFailed: 'Failed to query token balance',
  walletTransactionFailed: 'Transaction failed, please try again later',
  walletUserEthBalance: 'User ETH balance',
  walletUserRejected: 'User cancelled transaction authorization',
  walletUserTokenBalance: 'User token balance',
  walletUsingSmartContract: 'Using smart contract address as authorization target',
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    'Network timeout, please go to the order list to view the order',
  weiKaiQiZhiNengJiaoYi: 'Intelligent trading is not enabled',
  weiRenZheng: 'Not verified',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: 'Why do I need to register for an account?',
  weiTongGuo: 'Did not pass',
  woDeZhuCeXinXiHuiBeiBaoMiMa: 'Will my registration information be kept confidential?',
  woKeYiGengGaiWoDeZhuCeXinXiMa: 'Can I change my registration information?',
  woKeYiZhuCeDuoGeZhangHuMa: 'Can I register multiple accounts?',
  xiaCiShouYiShiJian: 'Next earnings time',
  xiaDanChengGong: 'successfully ordered',
  xinGongNengShangXian: 'New features are online!',
  xinMiMa: 'New Password',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: 'Demo accounts cannot use this feature',
  yanShiZhangHuBuNengChuangJianZhiNengJiaoYi:
    'Transaction failed: Automatic trading strategy cannot be created in demo account',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi: 'Demo accounts cannot use intelligent trading',
  yanShiZhangHuYiJinYong: 'Demo account disabled',
  yiDaoQi: 'be expired',
  yiFenRun: 'Profit has been divided',
  yiFenRunTianShu: 'Number of profit-sharing days',
  yiHuanKuan: 'Repaid',
  yiJuJue: 'rejected',
  yiQieHuanWeiXuNiZhangHu: 'Switched to Demo Account',
  yiQieHuanWeiZhenShiZhangHu: 'Switched to Live Account',
  yiRenZheng: 'verified',
  yiWanCheng: 'completed',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    'Some websites may allow users to register multiple accounts, but most websites only allow each user to register one account. \nIf you attempt to register multiple accounts, your account may be banned or deleted.',
  zhangFu: 'Increase',
  zhenFu: 'amplitude',
  zhuCeChengGong: 'registration success',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    'Registering an account allows you to use the features of the Site or Application more conveniently and protects your personal information.',
  zhuCeZhangHuXuYaoShiMoXinXi: 'What information is needed to register an account?',
  zongLiXi: 'total interest',
  zuiDiJia: 'lowest price',
}
